module.exports = __webpack_public_path__ + "7348d045037ede9e5514779600b61d0d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/holiday-sweater-s.png
// module id = 1907
// module chunks = 0